import { Helmet } from 'react-helmet-async';
import { LoginForm } from '@/components/auth/LoginForm';

export function LoginPage() {
  return (
    <>
      <Helmet>
        <title>Login - Urban Finch Admin</title>
      </Helmet>
      <LoginForm />
    </>
  );
}
